import { useQuery } from "@tanstack/react-query";
import { QUERY_KEY } from "../keys";
import { API_COUPON } from "../apis";
import { CouponResponse } from "../apis/types/couponResponse";

export const useGetCoupon = (params?: { [key: string]: string }) => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_COUPON_LIST, params],
        queryFn: () => API_COUPON.getCouponList<CouponResponse>({ ...params }),
        staleTime: 0,
    });
    return { data, isLoading };
};
